import { createRequestActions } from '../../utils';
import * as editInciListFormTypes from './editInciListFormTypes';

export const saveForm = createRequestActions(
  editInciListFormTypes.SAVE_FORM,
  data => data,
  ({ ProductId }) => ({ ProductId }),
);
